import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState = {
  hasLimitReached: false,
};

const dailyMessageLimitSlice = createSlice({
  name: "dailyMessageLimit",
  initialState,
  reducers: {
    setDailyMessageLimit: (state, action: PayloadAction<any>) => {
      state.hasLimitReached = action.payload;
    },
    clearDailyMessageLimit: (state) => {
      state.hasLimitReached = false;
    },
  },
});

export const {
  setDailyMessageLimit,
  clearDailyMessageLimit
} = dailyMessageLimitSlice.actions;
export const DailyMessageLimitReducer = dailyMessageLimitSlice.reducer;
